import { getRequest } from "./axios";

export const getPegsReservation = htConfCode => getRequest(`pegs/reservation/${htConfCode}`);
